import React, {useEffect, useState} from 'react';
import './ProjectRecord.sass'
import {Grid, useMediaQuery, useTheme} from "@mui/material";
import {Link} from "react-router-dom";

function ProjectRecord({to, title, subtitle, desc, img, imgAlt, bgColor, color='light', cursor}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [isDark, setIsDark] = useState(false)

    useEffect(() => {
        setIsDark(color === 'dark')
    }, [color])

    return (
        <Link to={to}>
            <Grid
                container
                className={`project_record ${isMobile && 'project_record_mobile'}`}
                style={{background: bgColor}}
                onMouseEnter={() => cursor.setText('Click Me!')}
                onMouseLeave={() => cursor.removeText()}
                onClick={() => cursor.removeText()}
            >
                <Grid item xs={1} />
                <Grid item xs={10}>
                    <Grid container spacing={'1rem'}>
                        <Grid item xs={12} md={6}>
                            <h2 className={`project_record__title ${isDark && 'project_record__title_dark'}`}>{title}</h2>
                            <h3 className={`project_record__subtitle ${isMobile && 'project_record__subtitle_mobile'} ${isDark && 'project_record__subtitle_dark'}`}>{subtitle}</h3>
                            <p className={`project_record__desc ${isDark && 'project_record__desc_dark'}`}>{desc}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <img src={img} alt={imgAlt} className={`project_record__img ${isMobile && 'project_record__img_mobile'}`} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1} />
            </Grid>
        </Link>
    );
}

export default ProjectRecord;